import { render, staticRenderFns } from "./SmtpRelayForm.vue?vue&type=template&id=c61a7864&scoped=true"
import script from "./SmtpRelayForm.vue?vue&type=script&lang=js"
export * from "./SmtpRelayForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61a7864",
  null
  
)

export default component.exports